import React from 'react';
import PropTypes from 'prop-types';

// This is duplicated in shared-components
const SelectFieldHOC = (Component) => {
  class hoc extends React.Component {
    constructor (props) {
      super(props);

      this.isValid = this.isValid.bind(this);
    }

    isValid () {
      return this.props.isValid();
    }

    componentDidUpdate (prevProps) {
      if (this.props.defaultValue !== prevProps.defaultValue) {
        const { value, onChange } = this.props.input;
        if (!value && this.props.defaultValue) {
          onChange(this.props.defaultValue);
        }
      }
    }

    render () {
      return <Component {...this.props} />;
    }
  }

  hoc.propTypes = {
    dispatch: PropTypes.func
  };

  return hoc;
};

export default SelectFieldHOC;
